/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
export const CSS = {
    stepBar: "step-bar",
    stepBarActive: "step-bar--active",
    stepBarComplete: "step-bar--complete",
    stepBarDisabled: "step-bar--disabled",
    stepBarError: "step-bar--error",
    stepBarInActive: "step-bar--inactive",
};
export const StepBar = ({ disabled, active, complete, error, key, }) => (h("svg", { class: {
        [CSS.stepBar]: true,
    }, key: key }, h("rect", { class: {
        [CSS.stepBarActive]: active,
        [CSS.stepBarComplete]: complete,
        [CSS.stepBarDisabled]: disabled,
        [CSS.stepBarError]: error,
        [CSS.stepBarInActive]: true,
    }, width: "100%", x: "0", y: "0" })));
//# sourceMappingURL=step-bar.js.map
